import {
    applyMiddleware,
    compose,
    createStore,
    GenericStoreEnhancer,
    StoreEnhancerStoreCreator
} from "redux";
import { createLogger } from "redux-logger";

export default function Productionize<S>(middleware) {
    if (process.env.NODE_ENV !== "production") {
        const loggerMiddleware = createLogger();
        middleware = [...middleware, loggerMiddleware];
    }

    const windowIfDefined =
        typeof window === "undefined" ? null : (window as any);
    // If devTools is installed, connect to it
    const devToolsExtension =
        windowIfDefined &&
        (windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__ as () => GenericStoreEnhancer);

    const createStoreWithMiddleware = compose<StoreEnhancerStoreCreator<S>>(
        applyMiddleware(...middleware),
        devToolsExtension
            ? devToolsExtension()
            : <S>(next: StoreEnhancerStoreCreator<S>) => next
    )(createStore);

    return createStoreWithMiddleware;
}
